<template>
  <div v-if="patInfo !== undefined && patInfo !== null">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row class="borde-azul-reducir">
      <b-col :cols="mostrarDetalle?5:12" class="borde-azul-reducir-fondo">
        <b-row style="height: 100px">
          <div style="text-align: right;position: absolute; width: 100%;z-index: 100;">
            <b-badge v-if="patInfo.idTipoPaciente === 1"
                     style="border:solid gray 1px; background:white; color:black;">{{ patInfo.tipoPaciente }}
            </b-badge>
            <b-badge v-else style="background:#eefff1; color:#49c37f;">{{ patInfo.tipoPaciente }}</b-badge>
          </div>
          <b-col cols="3">
            <div v-if="patInfo !== undefined && patInfo.idSexo !== undefined && patInfo.idSexo < 3"
            style="width:160%;margin-top:4px">

              <img alt="paciente" style="max-height:100px" v-if="patInfo.idSexo===1" src="@/assets/paciente/paciente.png"/>
              <img alt="paciente" style="max-height:100px" v-if="patInfo.idSexo===2" src="@/assets/paciente/paciente2.png"/>

            </div>

            <img alt="paciente" v-else style="max-height:100px" src="@/assets/paciente/paciente3.png"/>
          </b-col>
          <b-col cols="7">
            <div style="top:20%;position: relative;font-size: 14px;margin-left: 25px; width: 116%">
              <span style="color: #FFFFFF; font-weight: bold; font-size: 12px">{{ patInfo.nombrePaciente }}</span>
              <p class="mt-2" style="color: #FFFFFF; font-size: 12px">{{ patInfo.fechaNacimientoCompleta }}</p>
            </div>
          </b-col>
          <b-col xm="0" sm="0" md="0" lg="2" xl="2">
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="7" v-if="mostrarDetalle">
        <b-row class="detalle-formulario" style="margin-top: 8px">
          <b-col xm="12" sm="12" md="12" lg="3" xl="3" class="mb-2">
            <label>ID paciente</label>
            <span>{{ patInfo.idPaciente }}</span>
          </b-col>
          <b-col xm="12" sm="12" md="12" lg="3" xl="3" class="mb-2">
            <label>Confianza %</label>
            <span>{{ patInfo.confianza }}</span>
          </b-col>
          <b-col xm="12" sm="12" md="12" lg="6" xl="6" class="mb-2">
            <label style="display: block;">Último tratamiento</label>
            <span style="display: inline !important;">{{ patInfo.ultimoTratamiento }}</span>
            <span style="display: inline !important;"
                  v-if="patInfo.ultTrataDesde !== undefined && patInfo.ultTrataDesde !== null"> ({{patInfo.ultTrataDesde}})</span>
          </b-col>
          <b-col xm="12" sm="12" md="12" lg="4" xl="4" class="mt-3">
            <div v-if="datosContactoPaciente.length > 0" class="d-flex" style="gap: 10px">
              <label id="popover-medio-contacto">Info de contacto <font-awesome-icon :icon="['fas', 'chevron-up']" :class="{ 'rotate-chevron': popoverAbierto }" /></label>
              <em
                  class="edit_outline_svg"
                  style="width: 21px; cursor: pointer"
                  @click="editarDatosContacto"
                  v-b-tooltip.hover.topleft.v-light
                  title="Editar datos de contacto">
              </em>
              <b-popover
                  v-if="datosContactoPaciente.length > 0"
                  :target="'popover-medio-contacto'"
                  triggers="click blur"
                  placement="bottom"
                  @shown="popoverAbierto = true"
                  @hidden="popoverAbierto = false"
                  style="max-width: max-content !important;"
              >
                <div class="list-group list-group-flush">
                  <span
                      v-for="contacto in datosContactoPaciente.filter(item => item.preferente)"
                      :key="contacto.idMedioContacto"
                      class="list-item-contact p-0 "
                      style="font-size: 11px"
                  >
                    <b-icon v-if="contacto.idMedioContacto === 1" :icon="'house-fill'" class="mr-1" style="color: #AFB7BE"/>
                    <b-icon v-if="contacto.idMedioContacto === 2" :icon="'telephone-fill'" class="mr-1" style="color: #AFB7BE"/>
                    <b-icon v-if="contacto.idMedioContacto === 3" :icon="'at'" class="mr-1" style="color: #AFB7BE"/>
                    <b-icon v-if="contacto.idMedioContacto === 4" :icon="'briefcase-fill'" class="mr-1" style="color: #AFB7BE"/>
                    {{ obtenerTipoContacto(contacto.idMedioContacto) }} <strong>{{ contacto.contacto }}</strong>
                  </span>
                </div>
              </b-popover>
            </div>

          </b-col>
          <b-col xm="12" sm="12" md="12" lg="5" xl="5" class="mb-2">
              <span v-if="patInfo.ptiActivo !== undefined && patInfo.ptiActivo !== null">
                PTI ACTIVO
              </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: "cardPerfilPaciente",
  components: {},
  props: {
    mostrarDetalle: {
      likes: Boolean,
      default: true
    },
    patInfo: {
      likes: Object,
      required: false,
      default: null
    },
    datosContactoPaciente: Array,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    popoverAbierto: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  whatch: {},
  computed: {

  },
  methods: {
    editarDatosContacto() {
      this.$emit("editarDatosContacto");
    },

    obtenerTipoContacto(idMedioContacto) {
      if (idMedioContacto === 1) return 'Teléfono Casa:';
      if (idMedioContacto === 2) return 'Celular:';
      if (idMedioContacto === 3) return 'Correo:';
      if (idMedioContacto === 4) return 'Teléfono Trabajo:';
    },
  }
}
</script>

<style scoped>
.rotate-chevron {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.popover{
  max-width: max-content !important;
}
</style>
